import { Chart, CategoryScale } from "chart.js/auto";
import { useRef } from "react";
import { Bar } from "react-chartjs-2";
export const BarChart = ({ chartData, clickHandler }) => {

  //Chart.register(CategoryScale);
  const chartRef = useRef(null)

  return (
    <div className="chart-container">
      {/* <h4 style={{ textAlign: "center" }}>{chartData.datasets[0].label}</h4> */}
      <Bar
        id="barChart"
        ref={chartRef}
        redraw={true}
        data={chartData}
        options={{
          plugins: {
            title: {
              display: true,
              text: ""
            },
            legend: {
              display: false
            }
          }
        }}
        onClick={(e) => {
          //console.log(e)
          const chart = Chart.getChart("barChart");
          const points = chart.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true);

          if (points.length) {
            const firstPoint = points[0];
            const label = chart.data.labels[firstPoint.index];
            const id = chart.data.datasets[firstPoint.datasetIndex].ids[firstPoint.index];
            const value = chart.data.datasets[firstPoint.datasetIndex].data[firstPoint.index];

            clickHandler(id, label, value)
            //console.log("Graph Part Selected => ", id, label, value)
          }

        }}
      />
    </div>
  );
};